const axios = require('axios')
const config = require('./config')

const axiosInstance = axios.create({
  baseURL: config.SERVER_URL,
})

module.exports = axiosInstance
